export default __webpack_public_path__ + "static/media/toNaturalMoisturizing.a1782765.webp";